import React from 'react';
import { IconMoonStars, IconSun } from '@tabler/icons-react';
import styles from './ShellThemeToggle.module.css';

type ShellThemeToggleProps = {
  enabled: boolean;
  onToggle: () => void;
  testId: string;
  testIdAlias?: string;
};

export const ShellThemeToggle: React.FC<ShellThemeToggleProps> = ({
  enabled,
  onToggle,
  testId,
  testIdAlias,
}) => {
  const label = enabled ? 'Disable night mode' : 'Enable night mode';
  const Icon = enabled ? IconSun : IconMoonStars;

  return (
    <button
      className={`${styles.button} ${enabled ? styles.buttonActive : ''}`.trim()}
      type="button"
      onClick={onToggle}
      data-testid={testId}
      data-testid-alias={testIdAlias}
      aria-label={label}
      aria-pressed={enabled}
      title={label}
    >
      <Icon
        className={styles.icon}
        data-testid={`${testId}-${enabled ? 'sun' : 'moon'}-icon`}
      />
    </button>
  );
};
